// Sets the "Restricted Data Processing" flag for California users
if (typeof window !== 'undefined') {
  window['googletag'] = window['googletag'] || { cmd: [] };
  window['googletag'].cmd.push(function() {
    // This tells Google to use restricted data processing
    // You can toggle this based on a user's checkbox if you build one
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.requestNonPersonalizedAds = 1; 
  });
  console.log("CCPA Compliance script active.");
}